import { render, staticRenderFns } from "./ChipAplication.vue?vue&type=template&id=63878b8e&scoped=true&"
import script from "./ChipAplication.vue?vue&type=script&lang=ts&"
export * from "./ChipAplication.vue?vue&type=script&lang=ts&"
import style0 from "./ChipAplication.vue?vue&type=style&index=0&id=63878b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63878b8e",
  null
  
)

export default component.exports